import { roles } from '@nxsys/store/constants';
import ImportAgencyListing from '../../../modules/import/listing/ImportAgencyListing';
import ImportEmployeeListing from '../../../modules/import/listing/ImportEmployeeListing';
import ImportProspectListing from '../../../modules/import/listing/ImportProspectListing';
import ImportTimesheetListing from '../../../modules/import/listing/ImportTimesheetListing';

export const importConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/import/agencies',
    element: <ImportAgencyListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/import/employees-subcontractors',
    element: <ImportEmployeeListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/import/prospects',
    element: <ImportProspectListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/import/timesheets',
    element: <ImportTimesheetListing />,
  },
];
